// extracted by mini-css-extract-plugin
export var headline = "contact-us-panel-module--headline--4b2e5";
export var innerContent = "contact-us-panel-module--innerContent--88ee1";
export var primaryPanel = "contact-us-panel-module--primaryPanel--32d4e";
export var secondaryPanel = "contact-us-panel-module--secondaryPanel--93c46";
export var subheading = "contact-us-panel-module--subheading--d6c41";
export var typeform = "contact-us-panel-module--typeform--d8076";
export var wrapper = "contact-us-panel-module--wrapper--e43e5";